import { mappers } from './utils';
import { IGetTopBetsParams, TGetTopBetsResult } from './types';
import { fetchGetTopBetsByAnnouncement } from '../../../repositories/auction/v2/get-top-bets-by-announcement';
import { ETopBetsErrorCode } from '../../../redux/reducers/topBets';

export async function getTopBets(params: IGetTopBetsParams): Promise<TGetTopBetsResult> {
  const { httpApi, logger, parameters } = params;

  try {
    const response = await fetchGetTopBetsByAnnouncement({
      httpApi,
      parameters,
      mappers,
    });

    return response as TGetTopBetsResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос /get-top-bets-by-announcement/ на ФП',
      degradation: 'Пользователь не увидит список лидеров по объявлению',
    });
  }

  return {
    success: false,
    payload: ETopBetsErrorCode.fatalError,
  };
}
